import clsx from 'clsx';
import toast from 'react-hot-toast';

import { type ToastProps } from './show-toast.types';

export const showToast = ({
  message,
  title,
  timeout,
  error,
  success,
}: ToastProps) => {
  const titleColor = error
    ? 'text-error'
    : success
      ? 'text-success'
      : 'text-base-content';

  return toast.custom(
    (t) => (
      <div
        className={clsx(
          'pointer-events-auto rounded-lg border border-base-content/10 bg-base-300 px-4 py-3 shadow-2xl',
          t.visible ? 'animate-enter' : 'animate-leave',
        )}
      >
        <p className={clsx('text-sm font-semibold', titleColor)}>{title}</p>
        <p className='mt-0.5 text-xs text-base-content/60'>{message}</p>
      </div>
    ),
    { duration: timeout ?? 3000 },
  );
};
